import React, { useState, useEffect, useRef } from "react";
import "./chat_bot.css";
import "./chat_gpt_style.css";
import send_img from "./chat_img/send_gpt.png";
import time_lapse from "./chat_img/time_lapse.svg";
import pinned from "./chat_img/pinned.svg";
import chat_response from "./chat_img/ai_chat_icon.png";
import user_question from "./chat_img/user_question.png";
import { v4 as uuidv4 } from 'uuid';

import axios from "axios";
import api from "../../../services/api";
import {
  fetchChatRequestFollowUp,
  fetchChatRequestResponse,
  fetchClientsAccountsList,
  fetchDefaultAccountsQuestions,
} from "../../../services/accIqService";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import RenderHtmlFormattedText from "../../HtmlElements/RenderHtmlFormattedText";
import { useUser } from "../../../context/UserContext";
import ScreenLoader from "../../HtmlElements/ScreenLoader";
import ReviewComponent from "../../HtmlElements/ReviewComponent";
import { fetchReviewSectionEntityList, getMyLastViewedAccount, getUrlDetailsObj, getUserStatsObject, recordActivity } from "../../../services/commonService";
import { getCheckoutClientInfo } from "../../../services/authService";
const ChatComponent = () => {

  const { session_Id } = useParams();
  const [loader, setLoader] = useState(true);

  const d = new Date();
  const [currentSessionId, setCurrentSessionId] = useState(parseInt(session_Id) || '');
  const [chatContent, setChatContent] = useState([]);
  const [isPinned, setIsPinned] = useState(false);
  const [chatInput, setChatInput] = useState("");
  const [chatHistoryHeadings, setchatHistoryHeadings] = useState([]);
  
  const chatBodyRef = useRef(null); // Ref for the chat_body container
  // const lastDateDivRef = useRef(null); // Ref for the last date-div
  const lastMessageRef = useRef(null);

  const proxyUrl = "https://cors-anywhere.herokuapp.com/";
  const targetUrl = "http://127.0.0.1:4040/api/get_chat_response";

  const elementRef = useRef(null); // Create a ref
  const elementPromptTextAreaBlockRef = useRef(null); // Create a ref
  const [right_block_width, setRightBlockWidth] = useState(0); // State to store the width

  const [active_question_type, setActiveQuestionType] = useState("")
  const [active_question_index, setActiveQuestionIndex] = useState("")
  const [active_question_data_object, setActiveQuestionDataObject] = useState("")
  const [active_followup_question_index, setActiveFollowUpQuestionIndex] = useState("")

  const { user, my_favourites } = useUser();
  const [default_account_name, setDefaultAccountName] = useState("")

  const [response_loading, setResponseLoading] = useState(false);
  const [chat_started, setChatStarted] = useState(false);
  const [copied, setCopied] = useState(false);
  const [set_chat_div_padding , setChatDivPadding] = useState(350);
  const [reviewed_list , setReviewedList] = useState([]);
  const [copiedIndex, setCopiedIndex] = useState('');
  
  const navigate = useNavigate();

  const location = useLocation();

  const pageParsedData = getUrlDetailsObj(useLocation, useParams);

  useEffect(() => {
      pageParsedData.query_params = {}
      pageParsedData.query_params.tab = "";
      let userStat = getUserStatsObject(
        'AI Assistant',
        "page_load",
        "Page Source: AI Assistant" ,
        window.location.href,
        ''
      );
      userStat.url_details = pageParsedData;
      recordActivity(userStat);
  }, [])


  useEffect(() => {

    if(user?.company_name){

      const fetchAccountsData = async () => {
        try {
          
          const {checkoutClientId, checkoutClientName} = getCheckoutClientInfo();

          const clientNameNew = checkoutClientName || (user?.company_name || '');
          const clientCode = checkoutClientId || (user?.company_id || '');

          
          if (!clientCode) return [];
      
          const filter = { client_code: clientCode };
      
          const response = await api.get('/accounts/get_accounts', {
            params: { page: 1, limit: 2000, ...filter },
          });
      
          const local_db_records = response?.data?.result?.list || [];
      
          const mapped_with_request_id = local_db_records.reduce((acc, curr) => {
            acc[curr.request_id] = curr;
            return acc;
          }, {});
      
          const accounts = await fetchClientsAccountsList("", clientNameNew);
          const accounts_list = accounts?.accounts || [];
      
          const filteredAccounts = accounts_list.map((account) => {
            const acc_request_id = account?.request_id;
      
            if (acc_request_id && mapped_with_request_id[acc_request_id]?.id) {
              account._id = mapped_with_request_id[acc_request_id]?.id ?? '';
              account.isFavourite = mapped_with_request_id[acc_request_id]?.is_bookmarked_by_logged_in_user === 1 ? 1 : 0;
              account.status = mapped_with_request_id[acc_request_id]?.status ?? 0;
            }
      
            return account;
          }).filter((account) => {

            // const hasAccountAccess = user?.assigned_accounts?.includes(account?.company_code);

            const hasAccountAccess = (user?.role_key === 'SALES_DEMO' && account?.status === 1) ? true : (user?.assigned_accounts?.includes(account?.company_code));

            return account?._id && hasAccountAccess === true
          });
      
          return filteredAccounts;
        } catch (error) {
          console.error("Error fetching accounts:", error);
          return [];
        }
      };

      // Main Logic
      (async () => {
        
        var default_account_name = "";
        
          setLoader(true)

          const lastViewedAccount = await getMyLastViewedAccount();
          const all_accounts = await fetchAccountsData();

          // Sort accounts based on the display_name in company_details[0]
          all_accounts?.sort((a, b) => 
          a?.company_details?.[0]?.display_name?.localeCompare(b?.company_details?.[0]?.display_name) || 0
          );

          const firstAccountName = all_accounts?.[0]?.company_details?.[0]?.display_name || '';

          // Filter accounts that are marked as favorites (isFavourite is 1)
          const my_fav_accounts = all_accounts?.filter(account => account.isFavourite === 1);

          default_account_name = my_fav_accounts?.[0]?.company_details?.[0]?.display_name || firstAccountName || '';

          if(lastViewedAccount.length){
            var filteredLastViewed = all_accounts.filter((account) => {
              return account.company_code === lastViewedAccount[0]?.account_code;
            });
            if(filteredLastViewed.length){
              default_account_name = filteredLastViewed[0]?.company_details?.[0]?.display_name || default_account_name;
            }
          }

          setDefaultAccountName(default_account_name);

          setLoader(false);

      })();
    }

  }, [user?.company_name]);
  

  const default_group_quesions_data = [];

  useEffect(() => {
    if(currentSessionId){
      handleHistory(currentSessionId)
    }    
  }, [currentSessionId])

  useEffect(() => {
    getHistoryHeadings();
  }, []);

  const [group_questions_data, setGroupQuestionsData] = useState([])
  
  useEffect(() => {
    const fetchQuestions = async () => {
      if (default_account_name) {
        try {
          setLoader(true);

          const questions_list = await fetchDefaultAccountsQuestions("", default_account_name, user?.company_name);
  
          setGroupQuestionsData(questions_list); // Or process `questions_list` if needed

          setLoader(false);

        } catch (error) {
          console.error("Error fetching default account questions:", error);
        }
      }
    };
  
    fetchQuestions();
  }, [default_account_name]);
  

  const [list_of_questions, setListOfQuesions] = useState([]);

  const [followup_questions, setFollowUpQuestions] = useState([])

  const handleGroupQuestionSelection = (groupQuestionData, is_default) =>{

    if(groupQuestionData?.chat_type){
      pageParsedData.query_params = {}
      pageParsedData.query_params.tab = "";
      let userStat = getUserStatsObject(
        'AI Assistant',
        "view",
        "Page Source: AI Assistant Group Chat Type: "+groupQuestionData?.chat_type || '',
        window.location.href,
        ''
      );
      userStat.url_details = pageParsedData;
      
      recordActivity(userStat);
  
    }
    
    if(is_default === false){
      
      handleNewChange(1);

    }else{
    //   setChatInput("");
    // setActiveQuestionIndex("")
    // setActiveFollowUpQuestionIndex("")
    // setFollowUpQuestions([])
    // setChatStarted(false);
    }

    setActiveQuestionType(groupQuestionData?.chat_type || '')

    setListOfQuesions(groupQuestionData?.chat_questions || [])
  }

  useEffect(() => {
    if(currentSessionId !== ''){
      handleGroupQuestionSelection(group_questions_data?.[0], true)
    }
  }, [group_questions_data])

  /*
  const getFormatCurrentDate = (date_string = "") => {
    var now =  "";
    if(date_string){
      now = new Date(date_string.toLocaleString());
    }else{
      now = new Date();
    }
  
    const day = now.getDate();
    const month = now.toLocaleString('default', { month: 'short' }); // Get short month name
    const year = now.getFullYear();
  
    let hours = now.getHours();
    const minutes = now.getMinutes().toString().padStart(2, '0'); // Add leading zero if needed
    const ampm = hours >= 12 ? 'PM' : 'AM';
    
    hours = hours % 12 || 12; // Convert to 12-hour format
  
    return `${day} ${month} ${year} ${hours}.${minutes} ${ampm}`;
  };
  */

  const getFormatCurrentDate = (date_string = "") => {
    let now;
  
    if (date_string) {
      // Parse the date string as UTC
      now = new Date(date_string);
        
      // // Get date components
      // var day = now.getUTCDate().toString().padStart(2, '0'); // Day in UTC
      // var month = now.toLocaleString('default', { month: 'short', timeZone: 'UTC' }); // Month in UTC
      // var year = now.getUTCFullYear(); // Year in UTC
    
      // // Get time components
      // var hours = now.getUTCHours(); // Hours in UTC
      // var minutes = now.getUTCMinutes().toString().padStart(2, '0'); // Minutes in UTC
      // var ampm = hours >= 12 ? 'PM' : 'AM';
    
      // hours = hours % 12 || 12; // Convert to 12-hour format
      
    } else {
      now = new Date();
        
      
    }

    var day = now.getDate();
      var month = now.toLocaleString('default', { month: 'short' }); // Get short month name
      var year = now.getFullYear();
    
      var hours = now.getHours();
      var minutes = now.getMinutes().toString().padStart(2, '0'); // Add leading zero if needed
      var ampm = hours >= 12 ? 'PM' : 'AM';
      
      hours = hours % 12 || 12; // Convert to 12-hour format
  
    return `${day} ${month} ${year} ${hours}.${minutes} ${ampm}`;
  };
  
  
  
  useEffect(() => {
    if (elementRef.current) {
      const rect = elementRef.current.getBoundingClientRect(); // Get element dimensions
      setRightBlockWidth(rect.width); // Set the width
    }

    if (elementPromptTextAreaBlockRef.current) {
      const rect = elementPromptTextAreaBlockRef.current.getBoundingClientRect(); // Get element dimensions
      // console.log("rect height: ", rect.height)
      setChatDivPadding(rect.height + 130); // Set the width

      const chatBody = chatBodyRef.current;
      chatBody.scrollTop = chatBody.scrollHeight + 300;

    }

  }, [chatContent, followup_questions]); // Runs once after the component mounts

  const handleNewChange = (flg) => {
    setChatInput("");
    setActiveQuestionIndex("")
    setActiveFollowUpQuestionIndex("")
    setFollowUpQuestions([])
    setChatStarted(false);
    handleSessionId()
  };

  useEffect(() => {
    // Ensure class is removed before adding to avoid duplication issues
    setTimeout( () => {
      document.body.classList.remove('ai_assistant_body'); 
      document.body.classList.add('ai_assistant_body');
      // console.log('Class added for:', location.pathname);
    })
    // alert(1)
  }, [chat_started])

  const handleSendMessage = () => {
    if (!chatInput.trim()) return;
    const newMessage = { user: true, text: chatInput, triggered_date: getFormatCurrentDate("") };
    
    pageParsedData.query_params = {}
    pageParsedData.query_params.tab = "";
    let userStat = getUserStatsObject(
      'AI Assistant',
      "question_asked",
      "Page Source: AI Assistant: Quesion Entered : "+chatInput || '',
      window.location.href,
      ''
    );
    userStat.url_details = pageParsedData;
    recordActivity(userStat);


    setChatContent((prev) => {
        const updatedChatContent = [...prev, newMessage];
        
        // Process bot response based on the updated content
        const lastUserText = updatedChatContent
            .filter(message => message.user === true && message.text?.trim())
            .at(-2)?.text || '';


        
        if(active_question_data_object?.question?.toLocaleLowerCase() === chatInput?.toLocaleLowerCase()){


          var images_data = active_question_data_object?.images || []

      

          var images_html = "";
          if(images_data?.length > 0){
            for(var i = 0; i < images_data.length; i++){
              images_html += `<div class="row border m-3" > <img src="data:image/png;base64,${images_data[i]}" /> </div>` 
            }

            setResponseLoading(true);
            setChatStarted(true);
            setTimeout(async() => {
              
              const checkoutClientInfo = getCheckoutClientInfo();
              const client_name = checkoutClientInfo?.checkoutClientName || (user?.company_name || '');

              setResponseLoading(true);
              let followUpRes = await fetchChatRequestFollowUp(chatInput, client_name);
              let followUpsValues = Object.values(followUpRes?.completion || {});

              followUpsValues = Object.values(followUpsValues || {});

              let followUpsValuesNew = followUpsValues.slice( 0, 2);
              setFollowUpQuestions(followUpsValuesNew)

              getChatResponse(chatInput, "json", false, images_html);

              setResponseLoading(false);
            }, 2500)
            
            return updatedChatContent;
          }
        }
        
        var lastBotText = updatedChatContent
            .filter(message => message.bot === "bot" && message.text?.trim())
            .at(-1)?.text || '';


        // For templatize image answer, remove it from histroy to get response
        if (lastBotText && lastBotText.includes("<img ")) {
            lastBotText = "";
        }
        // End: For templatize image answer, remove it from histroy to get response

        var full_chat_input = chatInput;
        if ((lastUserText || lastBotText) && active_followup_question_index === "") {
            full_chat_input += "\nHistory: \nUSER PROMPT: "+lastUserText +" \nSYSTEM PROMPT: " + lastBotText;
        }

        getChatResponse(full_chat_input, "json", false, "");
        return updatedChatContent;
    });
    
    setChatInput("");
};


  const handleKeyPress = (event) => {

    if (/^[a-zA-Z0-9]$/.test(event.key)) {
      // console.log("Alphanumeric key pressed:", event.key);
      setActiveFollowUpQuestionIndex("") // Set Blank
    }

    if (event.key === "Enter") {
      handleSendMessage();
      event.preventDefault();
    }
  };

  const handleSessionId = (event) => {
    const d = new Date();
    setCurrentSessionId(Date.now());
    setChatContent([]);
  };

  const handleRecentChatLoad = (new_session_id) => {

    // console.log(" new_session_id : ", new_session_id)

    pageParsedData.query_params = {}
    pageParsedData.query_params.tab = "";
    let userStat = getUserStatsObject(
      'AI Assistant',
      "view",
      "Page Source: Recent Chat Open for SessionId: "+new_session_id || '',
      window.location.href,
      ''
    );
    userStat.url_details = pageParsedData;
    
    recordActivity(userStat);


    setTimeout(() => {
      window.location.replace(`/ai_assistant/${new_session_id}`);

    }, 1000)

  };

  useEffect(() => {

    if(currentSessionId){
      // Set param in url
      navigate(`/ai_assistant/${currentSessionId}`);
    }

  }, [currentSessionId])

  const handleHistory = (session_id) => {
    handleHistoryAPI(session_id);
    // console.log("Sending Request");
    // console.log(session_id);
  };

  const handleHistoryAPI = async (session_id) => {
    try {
      // console.log("Calling API");
      // console.log(session_id);

      const response = await api.post("/chat/get_previous_chats", {
        session_id: session_id,
      });

      // console.log(response);
      if (response.data.status === 201 || response.data.status === 200) {

        // console.log("response.data: ", response.data);

        var finalFormattedData = [];
        response.data.data.forEach(row_data => {
          let queData = {}
          let answerData = {}
          queData.user = true;

          var question_text = row_data?.question || '';

          if(question_text?.indexOf("History: ") >= 0){
            question_text = question_text.split("History: ")?.[0];
          }

          // console.log("row_data?.question || '' ", row_data?.question)

          queData.text = question_text;


          
          queData.triggered_date = getFormatCurrentDate(row_data?.modified_date) || '';

          finalFormattedData.push(queData);


          answerData.bot = 'bot';
          answerData.text = row_data?.answer || '';
          answerData.triggered_date = row_data?.modified_date || '';
          answerData.random_unique_id = row_data?.random_unique_id || '';

          finalFormattedData.push(answerData);

        });

        // console.log(" finalFormattedData ", finalFormattedData)
        if(finalFormattedData.length){

          if(user?.company_name){
            const like_list =  await fetchReviewSectionEntityList("", user?.company_name, 'ai_assistant', '');
        
            const reviewed_list = like_list
              ?.map(item => {
                return {entity_code: item?.entity_code || '', is_liked: item?.is_liked || ''}
              })
              ?.filter(list_data => list_data.entity_code !== "");

            setReviewedList(reviewed_list);
          }

          setActiveQuestionIndex("")
          setChatStarted(true);  
          setChatContent(finalFormattedData || [])
        }

        // setListOfQuesions(groupQuestionData?.chat_questions || [])

      } else {
        // add error
      }
    } catch (err) {
      // Exception
    }
    return;
  };

  const getHistoryHeadings = async () => {
    try {
      const response = await api.get("/chat/get_history", {});

      // console.log(response);
      if (response.status === 201 || response.status === 200) {
        setchatHistoryHeadings(response.data?.data || []);

        // console.log("response.data?.data || [] ", response.data?.data || [])
      } else {
      }
    } catch (err) {
      // Exception
    }
    return;
  };

  const getChatResponse = async (question, type = null, gpt_4 = false, default_response = "") => {
    // let data = {'answer' : 'Hi, This is random response.'}

    setActiveFollowUpQuestionIndex("")
    if(!default_response){
      setFollowUpQuestions([])
    }

    setResponseLoading(true);
    setChatStarted(true);
    var answer_text = "";

    var random_dynamic_response_id = uuidv4()

    const checkoutClientInfo = getCheckoutClientInfo();
    const client_name = checkoutClientInfo?.checkoutClientName || (user?.company_name || '');

    if(default_response){
      answer_text = default_response
    }else{
      let data = await fetchChatRequestResponse(question, client_name);

      answer_text = data?.completion || '';

      // data.intent = 'infographics';
      // answer_text = '{"infographics_url":"https://www.mnm.ai/static/infographics-boeing.png"}'; // Use double quotes for valid JSON

      // if (data?.intent === 'infographics') {
      if (answer_text.includes('infographics')) {
        try {
          // console.log("answer_text pre: ", answer_text)
          answer_text = answer_text.replace(/'/g, '"'); // Properly parse the JSON string
          answer_text = JSON.parse(answer_text);
          // console.log("answer_text post: ", answer_text)
          if (answer_text?.infographics_url) {
            const infographics_url = answer_text.infographics_url;
            answer_text = `<img src="${infographics_url}" width="500px">`;
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      }
    }

    const newAns = { bot: "bot", text: answer_text || "", random_unique_id: random_dynamic_response_id };
    setChatContent((prev) => [...prev, newAns]);

    setResponseLoading(false);

    if(default_response == ''){
      // setResponseLoading(true);
      const checkoutClientInfo = getCheckoutClientInfo();
      const client_name = checkoutClientInfo?.checkoutClientName || (user?.company_name || '');

      let followUpRes = await fetchChatRequestFollowUp(question, client_name);
      let followUpsValues = Object.values(followUpRes?.completion || {});


      followUpsValues = Object.values(followUpsValues || {});

      let followUpsValuesNew = followUpsValues.slice( 0, 2);
      setFollowUpQuestions(followUpsValuesNew);

    }


    try {
      const response = await api.post("/chat/save_record", {
        question: question,
        answer: answer_text || "",
        session_id: currentSessionId,
        random_unique_id: random_dynamic_response_id
      });

      if (response.data.status === 201 || response.data.status === 200) {
        //record saved
      } else {
        // add error
      }
    } catch (err) {
      // Exception
    }
    return;
    // const postFields = { question };

    // if (type) {
    //   postFields.type = type;
    // }

    // if (gpt_4) {
    //   postFields.gpt_4 = "gpt_4";
    // }

    // try {
    //   const api = axios.create({
    //     baseURL: 'http://127.0.0.1:4040',
    //     headers: {
    //       'Content-Type': 'application/json',
    //     },
    //   });

    //   const response = await api.post("/api/get_chat_response", postFields);

    //   // const response = await fetch("http://127.0.0.1:4040/api/get_chat_response", {
    //   //   method: "POST",
    //   //   mode: "no-cors",
    //   //   headers: {
    //   //     "Content-Type": "application/json",
    //   //   },
    //   //   body: JSON.stringify(postFields),
    //   // });

    //   if (!response.ok) {
    //     throw new Error(`HTTP error! status: ${response.status}`);
    //   }

    //   const data = await response.json();
    //   return data;
    // } catch (error) {
    //   console.error("Error fetching chat response:", error);
    //   return null; // Handle error response appropriately
    // }
  };

  const handleSetActivePrompt = (index) => {
    setActiveQuestionIndex(index)
    setActiveQuestionDataObject(list_of_questions?.[index])
    handleSetInput(list_of_questions?.[index]?.question_sample)

    pageParsedData.query_params = {}
    pageParsedData.query_params.tab = "";
    let userStat = getUserStatsObject(
      'AI Assistant',
      "view",
      "Page Source: AI Assistant Group Chat Type Question Selected: "+list_of_questions?.[index]?.question_sample || '',
      window.location.href,
      ''
    );
    userStat.url_details = pageParsedData;
    
    recordActivity(userStat);


  }

  const handleSelectFollowUpQues = (index) => {
    setActiveFollowUpQuestionIndex(index)
    handleSetInput(followup_questions?.[index] || '')
    
  }

  const handleSetInput = (requestText) => {
    setChatInput(requestText);
  };
  
  useEffect(() => {
    // Scroll to the last message when chatContent changes
    /*
    if (lastMessageRef.current) {
      lastMessageRef.current.scrollIntoView({ 
        behavior: "smooth",
        block: "nearest",
       // inline: "start",
       });
    }
    */
    
    setTimeout(() => {
      if (chatBodyRef.current && lastMessageRef.current) {
        const chatBody = chatBodyRef.current;
        chatBody.scrollTop = chatBody.scrollHeight + 800;
      }
    }, 3000)

  }, [chatContent]);

  const handleCopyToClipboard = (response_text, copied_index) => {
    
    const textToCopy = response_text;
    navigator.clipboard.writeText(textToCopy).then(() => {
      setCopied(true);
      setCopiedIndex(copied_index);
    });

    setTimeout(() => {
      setCopied(false);
      setCopiedIndex('');
    }, 2000);
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });

    // Ensure class is removed before adding to avoid duplication issues
    document.body.classList.remove('ai_assistant_body'); 
    document.body.classList.add('ai_assistant_body');
    // console.log('Class added for:', location.pathname);

    // Cleanup to remove class when navigating away
    return () => {
      // console.log('Class removed for:', location.pathname);
      document.body.classList.remove('ai_assistant_body');
    };
  }, [location.pathname]);

  return (
    <div className="container-fluid pt-4">
      {loader && <ScreenLoader/> }
         <div className="ai_block">
        <h5 className="ai_head">
          <img src="/img/ai_assitant1.png" className="img_ai" alt="icon"/>
      AI Assistant · Your everyday Al companion</h5>
      </div>
      <div className="wrapper mnm_chatbot mnm_chatbotfull_wrapper">
   
        <div className="custom_block_chat">
          <div className="left_block">
            <div className="chatfull_left">

              <div className="new_chat_block">
                <a onClick={() => handleNewChange(1)} className="new_chat_text">
                  <img
                    src="/img/new_chat.png"
                    className="new_chat_img"
                    alt="new_chat"
                  />
                  New Chat
                </a>
              </div>
              <div className="clearfix"></div>
              <div className="recent_chat_block">
                <h5 className="recent_chat_head">Top Prompters</h5>
                <ul className="recent_chat_list_ul">
                  {group_questions_data.length > 0 && group_questions_data.map((group_questions, index) => {
                    return <li className={`recent_chat_list_li cursorP ${group_questions?.chat_type === active_question_type ? 'active': ''}`} key={index} onClick={() => handleGroupQuestionSelection(group_questions, false)}>
                          <a
                            className="recent_chat_link"
                          >
                            {group_questions?.chat_type}
                          </a>
                      </li>
                  })
                  }

                </ul>
              </div>
              <div className="recent_chat_block custom_pad_bt_100">
                <h5 className="recent_chat_head">Recent Chats</h5>
                <ul className="recent_chat_list_ul">
                  {chatHistoryHeadings.length > 0 && chatHistoryHeadings.map((headInfo, index) => {
                    return <li className="recent_chat_list_li" key={index}>
                        <a onClick={() => handleRecentChatLoad(headInfo?._id) } className="recent_chat_link cursorP">
                          {headInfo?.heading}
                        </a>
                      </li>
                  })
                  }

                  {/* <li className="recent_chat_list_li">
                    <a href="#" className="recent_chat_link">
                      Revenue Growth Stagnation
                    </a>
                  </li>
                  <li className="recent_chat_list_li">
                    <a href="#" className="recent_chat_link">
                      Customer Retention Issues
                    </a>
                  </li>
                  <li className="recent_chat_list_li">
                    <a href="#" className="recent_chat_link">
                      Data Security Concerns
                    </a>
                  </li>
                  <li className="recent_chat_list_li">
                    <a href="#" className="recent_chat_link">
                      Primary Business Challenges
                    </a>
                  </li> */}
                </ul>
              </div>
            </div>
          </div>
          <div className="right_block" ref={elementRef}>
            {/* <div className="export_block">
            <div className="container">
              <a href="/clients_accounts" className="btn btn btn-light float-left">
                <i className="fa fa-arrow-left" aria-hidden="true"></i> Back
              </a>
              <span className="mr-3 pinned_top" style={{ display: "none" }}>
                <img
                  src="/img/chat_img/pinned.svg"
                  width="16"
                  alt="icon"
                  className="without_pinned"
                  style={{ display: !isPinned ? "inline-block" : "none" }}
                />
                <img
                  src="/img/chat_img/pinned_filled.svg"
                  width="16"
                  alt="icon"
                  className="with_pinned"
                  style={{ display: isPinned ? "inline-block" : "none" }}
                />
              </span>
            </div>
          </div> */}
            <div
              id="content"
              className={`${chat_started === false ? "d-none" : ""}`}
            >
              <div className="chat_body chat_login" ref={chatBodyRef} style={{
                paddingBottom: set_chat_div_padding+"px"
              }} >
                {chatContent.map((msg, idx) => {


                const reviewed_data = reviewed_list.filter(list => list.entity_code === msg?.random_unique_id )

                  
                  return msg.user ? (
                    <div key={`response_key_${idx}`}>
                      <div 
                      key={`my_${idx}`}
                      className="date-div" 
                      ref={idx === chatContent.length - 1 ? lastMessageRef : null} 
                      > {msg?.triggered_date}
                      {/* 1 Jan 2026 11.42 AM */}
                      </div>
                      <div className="chat-message user-message" key={idx}>
                        {/* <img src={user_question} height="35" className="img-responsive"/> */}
                        <p>{msg.text}</p>
                      </div>
                    </div>
                  ) : (
                    <div className="chat-response bot-message" 
                      key={idx}  
                    >
                      {msg?.text && 
                      <>
                        <img src={chat_response} height="20" className="img-responsive"></img>
                        <h6>
                          <a href="#" className="copy_chat d-none">
                            <i className="far fa-copy mr-2"></i>
                          </a>
                          <RenderHtmlFormattedText htmlContent={msg?.text} />
                          <br />
                          <div className="like_dislike">
                            <span className="link cursorP" onClick={ () => handleCopyToClipboard(msg?.text, idx)}>
                            
                            {/* {copied ? 
                              <i
                                className="fa fa-check green mr-2 pt-1 pb-1"
                                aria-hidden="true"
                              ></i> 
                              :  
                              <i
                                className="fa fa-clone mr-2 pt-1 pb-1"
                                aria-hidden="true"
                              ></i>
                            } */}

                            {copied && copiedIndex === idx ? 
                              <i
                                className="fa fa-clipboard green mr-2 pt-1 pb-1"
                                aria-hidden="true"
                              ></i> 
                              :  
                              <i
                                className="fa fa-clone mr-2 pt-1 pb-1"
                                aria-hidden="true"
                              ></i>
                            }
                              
                            </span>

                            {msg?.random_unique_id && <ReviewComponent reviewObj={
                                    {
                                      "section": "ai_assistant",
                                      "entity_code":  msg?.random_unique_id || '',
                                      "like_status": reviewed_data?.[0]?.is_liked || '',
                                      "account_code": '',
                                      "account_name": '',
                                      "client_code": user?.company_id || '',
                                      "client_name": user?.company_name || '',
                                    }
                                } />
                            }

                            {/* {msg?.random_unique_id &&
                            <>
                            <span className="link">
                              <i
                                className="fa fa-thumbs-o-up mr-2 pt-1 pb-1"
                                aria-hidden="true"
                              ></i>
                            </span>
                            <span className="link">
                              <i
                                className="fa fa-thumbs-o-down fa-flip-horizontal mr-2 pt-1 pb-1"
                                aria-hidden="true"
                              ></i>
                            </span>
                            </>
                            } */
                            }

                          </div>

                          <div className="thumbs_wrapper d-none">
                            <a
                              id="inf_9894"
                              href=""
                              target="_blank"
                              data-toggle="popover"
                              data-trigger="hover"
                              data-placement="right"
                              className="info_icon"
                            >
                              <i className="fa fa-info-circle mr-2 grey_icon pt-1 pb-1"></i>
                            </a>
                            <br />
                          </div>
                        </h6>
                      </>
                      }

                    </div>
                  )}
                )}
              </div>
            </div>

            {/* Six Block Compnaion */}

            <div
              className={`companion_wrapper ${
                chat_started === true ? "d-none" : ""
              }`}
            >
              <div className="logo_block d-none">
                <img
                  src="/img/mnm_logo_inner.png"
                  alt="logo"
                  width="140"
                  className="main_logo"
                />
                <h5 className="every_text">Your everyday Al companion</h5>
              </div>
              <div className="question_box_block">
                <div className="row">

                  {list_of_questions.length > 0 &&
                  list_of_questions.map((quesData, index) => {
                    return <div className="col-md-4" key={index}>
                            <div className={`question-box cursorP ${index === active_question_index ? 'active' : ''}`}  onClick={() => handleSetActivePrompt(index)} >
                              <a  data-value="#" className="link">
                                <img
                                  src="/img/boxes_icon.png"
                                  alt="logo"
                                  width=""
                                  className="icon_box"
                                />
                                <p className="text_para">{quesData?.title}</p>
                              </a>
                              <p className="para_text_bottom">
                              {quesData?.question}
                              </p>
                            </div>
                      </div>
                  })
                }
                </div>
              </div>
            </div>

            {/* Six Block Compnaion */}

            <div
              className="chat_textarea_block"
              style={{ width: right_block_width + "px" }}

              ref={elementPromptTextAreaBlockRef}
            >
              {response_loading && <div className="loader"><img src="/img/loader.gif" width="70"/> </div>}
            
              <div className="chat-input-container">
              <div className="tags">
                <div className="promters_tags">
                {followup_questions && followup_questions.length > 0 &&
                  followup_questions.map((ques, q_index) => {
                    return <a onClick={()=> handleSelectFollowUpQues(q_index)} className={`tags_sub cursorP ${q_index === active_followup_question_index ? 'active' : '' }`} key={q_index}>  {ques} </a>
                  })
                }
                </div>
                
                {/* <div className="icon_textarea_top">
                  <span className="icon_top"><img src="/img/icon_top_text.png" className="view_icon"/>View Prompts</span>
                </div> */}
                
              </div>
              <div className="d-flex ask_me_anything_block">

                <textarea
                  id="chatSend"
                  name="chat_message"
                  placeholder="Ask me anything"
                  className="chat_field chat_message"
                  value={chatInput}
                  onChange={(e) => setChatInput(e.target.value)}
                  onKeyPress={handleKeyPress}
                ></textarea>
                <a id="fab_send" className="fab1" onClick={handleSendMessage}>
                  <img
                    src={send_img}
                    className="img-responsive"
                    height="30"
                    alt="Send"
                  />
                </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatComponent;
